/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Cookiebanner_Decline1Inputs */

const id_components_cookiebanner_decline1 = /** @type {(inputs: Components_Cookiebanner_Decline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolak`)
};

const ms_components_cookiebanner_decline1 = /** @type {(inputs: Components_Cookiebanner_Decline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolak`)
};

const da_components_cookiebanner_decline1 = /** @type {(inputs: Components_Cookiebanner_Decline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afvis`)
};

const de_components_cookiebanner_decline1 = /** @type {(inputs: Components_Cookiebanner_Decline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ablehnen`)
};

const en_us2_components_cookiebanner_decline1 = /** @type {(inputs: Components_Cookiebanner_Decline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decline`)
};

const es_es2_components_cookiebanner_decline1 = /** @type {(inputs: Components_Cookiebanner_Decline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechazar`)
};

const es_mx2_components_cookiebanner_decline1 = /** @type {(inputs: Components_Cookiebanner_Decline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechazar`)
};

const fil_components_cookiebanner_decline1 = /** @type {(inputs: Components_Cookiebanner_Decline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggihan`)
};

const fr_components_cookiebanner_decline1 = /** @type {(inputs: Components_Cookiebanner_Decline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refuser`)
};

const it_components_cookiebanner_decline1 = /** @type {(inputs: Components_Cookiebanner_Decline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rifiuta`)
};

const hu_components_cookiebanner_decline1 = /** @type {(inputs: Components_Cookiebanner_Decline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elutasítás`)
};

const nl_components_cookiebanner_decline1 = /** @type {(inputs: Components_Cookiebanner_Decline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weigeren`)
};

const no_components_cookiebanner_decline1 = /** @type {(inputs: Components_Cookiebanner_Decline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avslå`)
};

const pl_components_cookiebanner_decline1 = /** @type {(inputs: Components_Cookiebanner_Decline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odrzucam`)
};

const pt_br2_components_cookiebanner_decline1 = /** @type {(inputs: Components_Cookiebanner_Decline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decline`)
};

const pt_components_cookiebanner_decline1 = /** @type {(inputs: Components_Cookiebanner_Decline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recusar`)
};

const ro_components_cookiebanner_decline1 = /** @type {(inputs: Components_Cookiebanner_Decline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refuz`)
};

const fi_components_cookiebanner_decline1 = /** @type {(inputs: Components_Cookiebanner_Decline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hylkää`)
};

const sv_components_cookiebanner_decline1 = /** @type {(inputs: Components_Cookiebanner_Decline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvisa`)
};

const vi_components_cookiebanner_decline1 = /** @type {(inputs: Components_Cookiebanner_Decline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từ chối`)
};

const tr_components_cookiebanner_decline1 = /** @type {(inputs: Components_Cookiebanner_Decline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reddet`)
};

const cs_components_cookiebanner_decline1 = /** @type {(inputs: Components_Cookiebanner_Decline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odmítnout`)
};

const bg_components_cookiebanner_decline1 = /** @type {(inputs: Components_Cookiebanner_Decline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отказвам`)
};

const ru_components_cookiebanner_decline1 = /** @type {(inputs: Components_Cookiebanner_Decline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отклонить`)
};

const uk_components_cookiebanner_decline1 = /** @type {(inputs: Components_Cookiebanner_Decline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відхилити`)
};

const ar_components_cookiebanner_decline1 = /** @type {(inputs: Components_Cookiebanner_Decline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رفض`)
};

const hi_components_cookiebanner_decline1 = /** @type {(inputs: Components_Cookiebanner_Decline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अस्वीकार करें`)
};

const th_components_cookiebanner_decline1 = /** @type {(inputs: Components_Cookiebanner_Decline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปฏิเสธ`)
};

const ja_components_cookiebanner_decline1 = /** @type {(inputs: Components_Cookiebanner_Decline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拒否する`)
};

const zh_cn2_components_cookiebanner_decline1 = /** @type {(inputs: Components_Cookiebanner_Decline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decline`)
};

const zh_hant1_components_cookiebanner_decline1 = /** @type {(inputs: Components_Cookiebanner_Decline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decline`)
};

const ko_components_cookiebanner_decline1 = /** @type {(inputs: Components_Cookiebanner_Decline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decline`)
};

/**
* | output |
* | --- |
* | "Decline" |
*
* @param {Components_Cookiebanner_Decline1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_cookiebanner_decline1 = /** @type {((inputs?: Components_Cookiebanner_Decline1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Cookiebanner_Decline1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_cookiebanner_decline1(inputs)
	if (locale === "ms") return ms_components_cookiebanner_decline1(inputs)
	if (locale === "da") return da_components_cookiebanner_decline1(inputs)
	if (locale === "de") return de_components_cookiebanner_decline1(inputs)
	if (locale === "en-US") return en_us2_components_cookiebanner_decline1(inputs)
	if (locale === "es-ES") return es_es2_components_cookiebanner_decline1(inputs)
	if (locale === "es-MX") return es_mx2_components_cookiebanner_decline1(inputs)
	if (locale === "fil") return fil_components_cookiebanner_decline1(inputs)
	if (locale === "fr") return fr_components_cookiebanner_decline1(inputs)
	if (locale === "it") return it_components_cookiebanner_decline1(inputs)
	if (locale === "hu") return hu_components_cookiebanner_decline1(inputs)
	if (locale === "nl") return nl_components_cookiebanner_decline1(inputs)
	if (locale === "no") return no_components_cookiebanner_decline1(inputs)
	if (locale === "pl") return pl_components_cookiebanner_decline1(inputs)
	if (locale === "pt-BR") return pt_br2_components_cookiebanner_decline1(inputs)
	if (locale === "pt") return pt_components_cookiebanner_decline1(inputs)
	if (locale === "ro") return ro_components_cookiebanner_decline1(inputs)
	if (locale === "fi") return fi_components_cookiebanner_decline1(inputs)
	if (locale === "sv") return sv_components_cookiebanner_decline1(inputs)
	if (locale === "vi") return vi_components_cookiebanner_decline1(inputs)
	if (locale === "tr") return tr_components_cookiebanner_decline1(inputs)
	if (locale === "cs") return cs_components_cookiebanner_decline1(inputs)
	if (locale === "bg") return bg_components_cookiebanner_decline1(inputs)
	if (locale === "ru") return ru_components_cookiebanner_decline1(inputs)
	if (locale === "uk") return uk_components_cookiebanner_decline1(inputs)
	if (locale === "ar") return ar_components_cookiebanner_decline1(inputs)
	if (locale === "hi") return hi_components_cookiebanner_decline1(inputs)
	if (locale === "th") return th_components_cookiebanner_decline1(inputs)
	if (locale === "ja") return ja_components_cookiebanner_decline1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_cookiebanner_decline1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_cookiebanner_decline1(inputs)
	return ko_components_cookiebanner_decline1(inputs)
});
export { components_cookiebanner_decline1 as "components.cookieBanner.decline" }